import type { LangMap } from "./index";

export const badges: LangMap = {
  it: {
    first_session: { label: "Prima sessione", description: "Hai completato la tua prima sessione di studio" },
    streak_7: { label: "Streak 7 giorni", description: "7 giorni consecutivi di studio" },
    streak_30: { label: "Streak 30 giorni", description: "30 giorni consecutivi di studio" },
    level_5: { label: "Livello 5", description: "Hai raggiunto il livello 5" },
    level_10: { label: "Livello 10", description: "Hai raggiunto il livello 10" },
    quiz_perfect: { label: "Quiz perfetto", description: "Hai risposto correttamente a tutte le domande di un quiz" },
  },
  en: {
    first_session: { label: "First session", description: "You completed your first study session" },
    streak_7: { label: "7-day streak", description: "7 consecutive days of studying" },
    streak_30: { label: "30-day streak", description: "30 consecutive days of studying" },
    level_5: { label: "Level 5", description: "You reached level 5" },
    level_10: { label: "Level 10", description: "You reached level 10" },
    quiz_perfect: { label: "Perfect quiz", description: "You answered every question correctly in a quiz" },
  },
  es: {
    first_session: { label: "Primera sesión", description: "Completaste tu primera sesión de estudio" },
    streak_7: { label: "Racha de 7 días", description: "7 días consecutivos de estudio" },
    streak_30: { label: "Racha de 30 días", description: "30 días consecutivos de estudio" },
    level_5: { label: "Nivel 5", description: "Alcanzaste el nivel 5" },
    level_10: { label: "Nivel 10", description: "Alcanzaste el nivel 10" },
    quiz_perfect: { label: "Cuestionario perfecto", description: "Respondiste correctamente todas las preguntas de un cuestionario" },
  },
  fr: {
    first_session: { label: "Première session", description: "Tu as terminé ta première session d'étude" },
    streak_7: { label: "Série de 7 jours", description: "7 jours consécutifs d'étude" },
    streak_30: { label: "Série de 30 jours", description: "30 jours consécutifs d'étude" },
    level_5: { label: "Niveau 5", description: "Tu as atteint le niveau 5" },
    level_10: { label: "Niveau 10", description: "Tu as atteint le niveau 10" },
    quiz_perfect: { label: "Quiz parfait", description: "Tu as répondu correctement à toutes les questions d'un quiz" },
  },
  de: {
    first_session: { label: "Erste Sitzung", description: "Du hast deine erste Lernsitzung abgeschlossen" },
    streak_7: { label: "7-Tage-Serie", description: "7 aufeinanderfolgende Lerntage" },
    streak_30: { label: "30-Tage-Serie", description: "30 aufeinanderfolgende Lerntage" },
    level_5: { label: "Level 5", description: "Du hast Level 5 erreicht" },
    level_10: { label: "Level 10", description: "Du hast Level 10 erreicht" },
    quiz_perfect: { label: "Perfektes Quiz", description: "Du hast alle Fragen eines Quiz richtig beantwortet" },
  },
  pt: {
    first_session: { label: "Primeira sessão", description: "Completaste a tua primeira sessão de estudo" },
    streak_7: { label: "Sequência de 7 dias", description: "7 dias consecutivos de estudo" },
    streak_30: { label: "Sequência de 30 dias", description: "30 dias consecutivos de estudo" },
    level_5: { label: "Nível 5", description: "Alcançaste o nível 5" },
    level_10: { label: "Nível 10", description: "Alcançaste o nível 10" },
    quiz_perfect: { label: "Quiz perfeito", description: "Respondeste corretamente a todas as perguntas de um quiz" },
  },
};
